import { SchoolEvent } from 'Src/models/event';
import { Tournament } from 'Src/models/tournament';

export const tournamentFixtureSchool = (tournament: Tournament, event: SchoolEvent, schoolId: string) =>
  [event.inviterSchool, ...(event.invitedSchools || []), ...(tournament.schools || [])]
    .find(school => school && String(school.id) === String(schoolId));

export function tournamentFixtureDisplay(tournament: Tournament, event: SchoolEvent) {
  const definition = tournament.competitionStructure?.published;
  const match = definition?.matches.find(item => item.eventId === event.id ||
    (event.tournamentStructureMatchId && item.id === event.tournamentStructureMatchId));
  return { match };
}
